module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1159.ba838890.png";